/**
 * @file 入口文件
 * @author WangZhuang
 */
import 'core-js/es/map';
import 'core-js/es/set';
import 'raf/polyfill';
import React from 'react';
import {render} from 'react-dom';
import {applyMiddleware, createStore, combineReducers} from 'redux';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import App from './App';
import {extendComponent, thunkMiddleware} from './util';
import reducers from './reducers';

const todoApp = combineReducers(reducers);
const store = createStore(todoApp, applyMiddleware(thunkMiddleware));


extendComponent()();

render(
    <Provider store={store}>
        <BrowserRouter basename="/m">
            <App />
        </BrowserRouter>
    </Provider>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js